import { Stack } from '@mantine/core';
import i18n from '../../../../../base-dictionary';
import { skyDark } from '../../../../../styles/design-tokens';
import { Icon } from '../../../../../ui-library/icon/icon';
import { Text } from '../../../../../ui-library/typography/typography';

type Props = {
  icon?: string;
  text?: string;
};

export const ContentPlaceholder = ({
  icon = 'mobiledata_off',
  text = i18n.t('strategy.initiative_performance.no_data'),
}: Props) => {
  return (
    <Stack h="100%" justify="center" align="center" gap={24}>
      <Icon name={icon} size={40} color={skyDark} />
      <Text size="regular" color={skyDark}>
        {text}
      </Text>
    </Stack>
  );
};
